// @flow
import { connect, Provider, useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';

import LinkPopup from '../popups/Link';
import * as FedExDeliveryContent from '../popups/content/FedExDelivery';
import * as SalesTaxContent from '../popups/content/SalesTax';
import * as PaypalContent from '../popups/content/Paypal';

import { trackBeginCheckout } from '../../utils/googleAnalytics';

import type { RailsContextType, ObjectType } from '@types/misc';
import type { TotalsType } from "../../reducers/cart";
import type { CartItemType } from "../../types/cart";

type CartTotalsProps = {
  totals: TotalsType,
};

function beginCheckout(cartItems: Array<CartItemType>) {
  trackBeginCheckout(cartItems);
  Rails.$('#checkout_steps')[0].style.display = 'block';
  window.location = '#checkout_steps';
}

function CartTotals({ totals }: CartTotalsProps) {
  const cartItems = useSelector(store => store.cart.items);

  return (
    <table id='shopPriceTable'>
      <tbody>
        <tr>
          <td className='title'>Item Total:</td>
          <td className='item' style={{ textAlign: 'right' }}>
            <div className='itemTotal'>
              <NumberFormat
                value={totals.item_total}
                displayType={'text'}
                thousandSeparator
                prefix={'$'}
                decimalScale={0}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td className='title'>
            <LinkPopup
              initialContent={FedExDeliveryContent}
              style={{ color: '#455056', textDecoration: 'underline' }}
            >
              FedEx Shipping
            </LinkPopup>
            :
          </td>
          <td className='item' style={{ textAlign: 'right' }}>
            FREE
          </td>
        </tr>
        <tr>
          <td className='title'>
            <LinkPopup
              initialContent={SalesTaxContent}
              style={{ color: '#455056', textDecoration: 'underline' }}
            >
              Sales Tax
            </LinkPopup>
            :
          </td>
          <td className='item' style={{ textAlign: 'right' }}>
            <div className='salesTax'>
              <NumberFormat
                value={totals.sales_tax}
                displayType={'text'}
                thousandSeparator
                prefix={'$'}
                decimalScale={2}
                fixedDecimalScale
              />
            </div>
          </td>
        </tr>
        <tr>
          <td className='title' style={{ padding: '20px 10px', fontSize: 14 }}>
            <span className='blue'>Order Total:</span>
          </td>
          <td
            className='item'
            style={{
              padding: '20px 10px',
              fontSize: 14,
              textAlign: 'right',
              paddingRight: 55
            }}
          >
            <span className='blue grandTotal'>
              <NumberFormat
                value={totals.order_total}
                displayType={'text'}
                thousandSeparator
                prefix={'$'}
                decimalScale={2}
                fixedDecimalScale
              />
            </span>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <div className='checkout'>
              <button
                className='blue button'
                style={{ width: 143 }}
                onClick={() => beginCheckout(cartItems)}
              >
                Checkout
              </button>{' '}
              or
              <a
                className='paypal-button'
                rel='nofollow'
                data-method='post'
                href='/orders/paypal_checkout'
              >
                <img src='https://www.paypal.com/en_US/i/btn/btn_xpressCheckout.gif' />
              </a>
              <LinkPopup initialContent={PaypalContent}>what's this?</LinkPopup>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

function mapStateToProps({ cart }: { cart: { totals: TotalsType } }): CartTotalsProps {
  return {
    totals: cart.totals
  };
}

function mapDispatchToProps(dispatch: Function): {} {
  return {};
}

const ConnectedCartTotals = connect(
  mapStateToProps,
  mapDispatchToProps
)(CartTotals);

export default (props: ObjectType, railsContext: RailsContextType) =>
  () => {
    const store = ReactOnRails.getStore('SharedReduxStore');

    return (
      <Provider store={store}>
        <ConnectedCartTotals {...{ ...props, railsContext }} />
      </Provider>
    );
  };
